<template>
  <div class="guest opportunity-requirements base">
    <v-menu open-on-hover top offset-y nudge-top="5" max-width="50%">
      <div class="text-xs-center" slot="activator">
        <div style="cursor: pointer;">
          <v-badge
            slot="activator"
            :color="themes.candidate.light[thumbsUp ? 'success' : 'error']"
            :value="loggedIn"
            class="requirement__badge"
            bottom
            left
          >
            <v-icon slot="badge" v-if="thumbsUp" dark small>mdi-thumb-up</v-icon>
            <v-icon slot="badge" v-else-if="thumbsDown" dark small>mdi-thumb-down</v-icon>
            <v-avatar :color="themes.candidate.light[requirementColor]" size="52">
              <v-avatar color="white" size="48">
                <v-icon v-if="icon" medium>
                  <!-- <v-icon v-if="icon" medium dark> -->
                  <!-- :color="themes.candidate.light[satisfied ? 'success' : 'error']" -->
                  {{ icon }}
                </v-icon>
                <v-avatar v-if="flagIcon" size="16">
                  <img
                    :class="
                      `flag-icon-background flag-icon-squared flag-icon-${flagIcon.toLowerCase()}`
                    "
                    style="padding: 16px"
                  />
                </v-avatar>
              </v-avatar>
            </v-avatar>
          </v-badge>
        </div>
        <div
          class="caption ellipses pt-1"
          :class="themes.candidate.light.mutedText"
          style="overflow: hidden; max-width: 57px; max-height: 38px; margin: auto;"
        >
          <slot></slot>
        </div>
      </div>
      <v-card flat dark v-if="tooltip">
        <v-card-text class="pa-1">
          <slot name="tooltip"></slot>
        </v-card-text>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  props: {
    flagIcon: String,
    icon: String,
    satisfied: Boolean,
    tooltip: { type: Boolean, default: false },
  },
  computed: {
    loggedIn() {
      return this.$store.getters['auth/loggedIn']
    },
    isCandidate() {
      return this.$store.getters['auth/role'] === 'candidate'
    },
    thumbsUp() {
      return this.satisfied || !this.isCandidate
    },
    thumbsDown() {
      return !this.thumbsUp
    },
    requirementColor() {
      if (!this.loggedIn) return 'muted'
      if (this.thumbsUp) return 'success'
      if (this.thumbsDown) return 'error'
    },
  },
}
</script>

<style lang="scss">
.guest.opportunity-requirements.base {
  .requirement__badge span {
    bottom: -4px;
    left: -2px;
  }
}
</style>
